import { useState } from "react";
import { useIntl } from "react-intl";
import isEqual from "lodash/isEqual";
import { Button, Input, Modal } from "../../../BP2Components";
import IntlMessages from "../../../../util/IntlMessages";

const CALL_AUTOMATION_METHOD_NAME = "CallAutomationServiceBusinessMethod";

const BusinessMethodsModal = ({
   isOpen,
   onClose,
   businessMethods,
   savedBusinessMethods,
   onChange,
   onSave,
}) => {
   const intl = useIntl();
   const [newMethodLabel, setNewMethodLabel] = useState("");
   const [newMethodUrl, setNewMethodUrl] = useState("");
   const [errors, setErrors] = useState({});

   const resetForm = () => {
      setNewMethodLabel("");
      setNewMethodUrl("");
      setErrors({});
   };

   const addMethod = () => {
      const nextErrors = {};
      if (!newMethodLabel.trim()) nextErrors.label = true;
      if (!newMethodUrl.trim()) nextErrors.url = true;
      if (Object.keys(nextErrors).length > 0) {
         setErrors(nextErrors);
         return;
      }
      setErrors({});
      onChange([
         ...businessMethods,
         {
            label: newMethodLabel.trim(),
            name: CALL_AUTOMATION_METHOD_NAME,
            parameters: { url: newMethodUrl.trim() },
         },
      ]);
      resetForm();
   };

   const removeMethod = (index) => {
      onChange(businessMethods.filter((_, i) => i !== index));
   };

   const handleSave = async () => {
      try {
         await onSave();
         resetForm();
         onClose();
      } catch {
         // onSave already showed Message.error — modal stays open
      }
   };

   const handleClose = () => {
      resetForm();
      onClose();
   };

   const hasNoChanges = isEqual(businessMethods, savedBusinessMethods);

   return (
      <Modal
         isOpen={isOpen}
         onOk={handleSave}
         onOkDisabled={hasNoChanges}
         onCancel={handleClose}
         onOkText={intl.formatMessage({
            id: "form.businessMethods.save",
            defaultMessage: "Zapisz metody",
         })}
         height={520}
      >
         <div className="form-builder-methods-modal">
            <h3>
               <IntlMessages id="form.businessMethods" defaultMessage="Metody biznesowe" />
            </h3>

            <div className="form-builder-methods-list">
               {businessMethods.length === 0 && (
                  <p style={{ color: "#999", fontSize: "12px" }}>
                     <IntlMessages
                        id="form.businessMethods.empty"
                        defaultMessage="Brak skonfigurowanych metod"
                     />
                  </p>
               )}
               {businessMethods.map((method, index) => (
                  <div
                     key={`${method.name}-${method.label}-${index}`}
                     className="form-builder-method-item"
                  >
                     <div className="form-builder-method-item-info">
                        <span className="form-builder-method-label">{method.label}</span>
                        <span className="form-builder-method-name">{method.name}</span>
                        {method.parameters?.url && (
                           <span className="form-builder-method-url">{method.parameters.url}</span>
                        )}
                     </div>
                     <Button
                        buttonType="outlined"
                        onClick={() => removeMethod(index)}
                        style={{ fontSize: "11px" }}
                     >
                        <IntlMessages id="global.delete" defaultMessage="Usuń" />
                     </Button>
                  </div>
               ))}
            </div>

            <div className="form-builder-method-add">
               <h4>
                  <IntlMessages
                     id="form.businessMethods.addMethod"
                     defaultMessage={`Dodaj metodę (${CALL_AUTOMATION_METHOD_NAME})`}
                  />
               </h4>
               <div className="form-builder-method-add-fields">
                  <label>
                     <IntlMessages
                        id="form.businessMethods.label"
                        defaultMessage="Nazwa wyświetlana"
                     />
                  </label>
                  <Input
                     placeholder="np. Wyślij do systemu"
                     value={newMethodLabel}
                     onChange={(e) => {
                        setNewMethodLabel(e.target.value);
                        if (errors.label) setErrors((prev) => ({ ...prev, label: false }));
                     }}
                     style={errors.label ? { borderColor: "#d90000" } : undefined}
                  />
                  <label>
                     <IntlMessages id="form.businessMethods.url" defaultMessage="URL" />
                  </label>
                  <Input
                     placeholder="np. https://..."
                     value={newMethodUrl}
                     onChange={(e) => {
                        setNewMethodUrl(e.target.value);
                        if (errors.url) setErrors((prev) => ({ ...prev, url: false }));
                     }}
                     style={errors.url ? { borderColor: "#d90000" } : undefined}
                  />
                  <Button buttonType="primary" onClick={addMethod} style={{ marginTop: "8px" }}>
                     + <IntlMessages id="form.businessMethods.add" defaultMessage="Dodaj" />
                  </Button>
               </div>
            </div>
         </div>
      </Modal>
   );
};

export default BusinessMethodsModal;
